import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

export const getBlogsApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/blogs`, { params });
};

export const getBlogCategoriesApi = () => {
  return axios.get(`${API_BASE_URL}/api/blogs/categories`);
};

export const createBlogApi = (payload) => {
  return axios.post(`${API_BASE_URL}/api/blogs`, payload);
};

export const getBlogByIdApi = (blogId) => {
  return axios.get(`${API_BASE_URL}/api/blogs/${blogId}`);
};

export const updateBlogApi = (blogId, payload) => {
  return axios.put(`${API_BASE_URL}/api/blogs/${blogId}`, payload);
};

export const deleteBlogApi = (blogId) => {
  return axios.delete(`${API_BASE_URL}/api/blogs/${blogId}`);
};

export const bulkBlogActionApi = (action, ids) => {
  return axios.post(`${API_BASE_URL}/api/blogs/bulk-action`, { action, ids });
};

export const listBlogCategoriesApi = () => {
  return axios.get(`${API_BASE_URL}/api/blogs/categories/list`);
};

export const createBlogCategoryApi = (name) => {
  return axios.post(`${API_BASE_URL}/api/blogs/categories`, { name });
};

export const deleteBlogCategoryApi = (id) => {
  return axios.delete(`${API_BASE_URL}/api/blogs/categories/${id}`);
};
